import React from "react"
import PropTypes from "prop-types"

const ArrowSidemenu = ({ fillColor }) => (
  <svg
    width="8"
    height="11"
    viewBox="0 0 8 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.1"
      d="M1.25 10L5.75 5.5L1.25 1"
      stroke={fillColor}
      strokeWidth="2"
    />
  </svg>
)

ArrowSidemenu.propsTypes = {
  fillColor: PropTypes.string,
}

ArrowSidemenu.defaultProps = {
  fillColor: "#e6e9ee",
}

export { ArrowSidemenu }
